import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import DOMPurify from 'dompurify';

@Pipe({
  name: 'safeHtml'
})
export class SafeHtmlPipe implements PipeTransform {

  constructor(private sanitizer: DomSanitizer) {}

  transform(value: string): SafeHtml {
    if (!value) return '';

    /** clean HTML with DOMPurify (XSS) */
    const sanitizedContent = DOMPurify.sanitize(value);

    /** return trusted safe HTML-Content, bypassing security */
    return this.sanitizer.bypassSecurityTrustHtml(sanitizedContent);
  }
}
